import { FC, SVGAttributes } from "react";

const Label: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 24,
  height = 24,
  fill = "#000",
  stroke = "#000",
  strokeWidth = 2,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Brand">
        <path
          id="Rectangle"
          d="M2 4C2 2.89543 2.89543 2 4 2H11.7574C12.2878 2 12.7965 2.21071 13.1716 2.58579L22.1716 11.5858C22.9526 12.3668 22.9526 13.6332 22.1716 14.4142L14.4142 22.1716C13.6332 22.9526 12.3668 22.9526 11.5858 22.1716L2.58579 13.1716C2.21071 12.7965 2 12.2878 2 11.7574V4Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
        <circle id="Oval" cx="6.5" cy="6.5" r="1.5" fill={fill} />
      </g>
    </svg>
  );
};

export { Label };
